import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  errorMessage: string;
  loginSuccess: boolean;
  loginError: boolean;

  constructor(
    public firebaseAuth: AngularFireAuth,
    private router: Router
  ) {
    this.loginSuccess = false;
    this.loginError = false;
  }

  doRegister(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(email, password).then(result => {
        this.loginSuccess = true;
        localStorage.setItem('loggedIn', 'true');
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }

  resetPassword(email) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().sendPasswordResetEmail(email)
      .then(res => {
        resolve(res);
      }, err => reject(err));
    });
  }

  doLogin(email, password) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password).then(result => {
        this.loginSuccess = true;
        localStorage.setItem('loggedIn', 'true');
        resolve(result);
      }).catch(error => {
        reject(error);
      });
    });
  }

  getCurrentUser() {
    const user =  firebase.auth().currentUser;
    return user;
  }

  logout(): void {
    this.loginSuccess = false;
    this.firebaseAuth.signOut().then(_ => this.router.navigate(['/login']));
  }

  sendPasswordlessSignIn(email: string) {
    const portalUrl = environment.posUrl;
    const dataSend = btoa(JSON.stringify({ email }));
    return firebase.auth().sendSignInLinkToEmail(email, {
      url: `${portalUrl}/magic-login?data=${dataSend}`,
      handleCodeInApp: true,
    }).then(() => Promise.resolve(true))
      .catch((err: any) => {
        console.log('error: ', err);
        return Promise.reject(err);
      })
  }

  passwordlessLogin(data: any) {
    const parsedData = JSON.parse(atob(data));
    if (this.firebaseAuth.isSignInWithEmailLink(window.location.href)) {
      return this.firebaseAuth.signInWithEmailLink(parsedData.email, window.location.href)
        .then(() => {
          return Promise.resolve(parsedData.email);
        }).catch((err) => {
          alert('Hubo un error procesando tu inicio de sesión');
          return Promise.reject(err);
        });
    }
  }
}
